import { useContext, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Mousewheel, Navigation, Autoplay } from "swiper";

// import { motion } from 'framer-motion'

import "swiper/css";
import "swiper/css/pagination";


import './ShowcaseScroll.css';
import { ConfigContext } from '../../../../assets/contexts/configContext';
import ProductCard from '../../../Catalog/ProductCard/ProductCard';
import { getRandomId } from '../../../../assets/utils/utils';
import useWindowSize from '../../../../assets/hooks/useWindowSize';
import ProductCardHero from '../../../Catalog/ProductCardHero/ProductCardHero';
import { Link } from 'react-router-dom';
import { CATALOG_MAIN_LINK, NEW_CATEGORY_LINK } from '../../../../assets/utils/constants';
import { SliderArrowIcon } from '../../../../assets/icons/promo100';

function ShowcaseScroll({
    item,
}) {

    const config = useContext(ConfigContext)
    const { cardTokens } = config
    const {
        cards_in_line,
    } = cardTokens
    const { width } = useWindowSize()
    console.log(item)
    const { title, products } = item.data[0]
    const [my_swiper, set_my_swiper] = useState({});
    const _id = getRandomId()
    return (
        <div className='showcase-scroll'>
            {title ? <h2 className='showcase-scroll__title'>{title}</h2> : null}
            <div className='showcase-scroll__items-slider'>
                <Swiper
                    slidesPerView={width <= 800 ? 'auto' : 2}
                    spaceBetween={width <= 800 ? 0 : 40}
                    loop={true}
                    pagination={{
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 4,
                    }}
                    mousewheel={{
                        forceToAxis: true,
                    }}
                    autoplay={{
                        delay: 6000,
                        disableOnInteraction: true,
                    }}
                    longSwipes={false}

                    modules={[Mousewheel, Pagination, Autoplay]}
                    preventInteractionOnTransition={true}
                    className="showcase-scroll__items"
                    onInit={(ev) => {
                        set_my_swiper(ev)
                    }}

                >
                    {products.map((slide, i2) => (
                        <SwiperSlide className="showcase-scroll__item" key={`promo-100-${item._id}-slide-${i2}`}>
                            <ProductCardHero
                                item={slide}
                                key={`showcase-scroll_${_id}products_item_${i2}`}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <button className='showcase-scroll__arrow-btn showcase-scroll__arrow-btn_left' type='button' onClick={() => {
                if (my_swiper) {
                    my_swiper.slidePrev()
                }
            }}>
                <SliderArrowIcon
                    mainClassName={'showcase-scroll__arrow'}
                    fillClassName={'showcase-scroll__arrow-fill'}
                />
            </button>
            <button className='showcase-scroll__arrow-btn showcase-scroll__arrow-btn_right' type='button' onClick={() => {
                if (my_swiper) {
                    my_swiper.slideNext()
                }
            }}>
                <SliderArrowIcon
                    mainClassName={'showcase-scroll__arrow showcase-scroll__arrow_rotated'}
                    fillClassName={'showcase-scroll__arrow-fill'}
                />
            </button>
            <div className='promo-catalog__all-line'>
                <Link className='promo-catalog__all-line-btn'
                    to={`/${CATALOG_MAIN_LINK}/${NEW_CATEGORY_LINK}`}
                >
                    Просмотреть все
                </Link>
            </div>
        </div>
    );
}

export default ShowcaseScroll